import React, { createContext } from "react";

const AppContext = createContext({
    toggleColorMode: () => { },
    mode: 'light', // Default value for the mode
});

export default AppContext;
